module.exports = __webpack_public_path__ + "img/avatar2.ecfa10a3.png";